<template>
  <div class="live2d">
    <div class="container" ref="container">
      <div class="bg"></div>
      <div id="__spine_player_container__"></div>
    </div>
    <div class="mask" @click="executeAnimation(1)">
      <div class="empty" v-if="isEmpty && !mainLive2d.loading">
        <img src="@/assets/zs_imgs/empty-img.png" alt="" />
        <div>资料暂时空缺，留言让版主加急</div>
      </div>
      <div class="loading" v-if="mainLive2d.loading">
        <div class="loader">
          <span class="item"></span>
          <span class="item"></span>
          <span class="item"></span>
          <span class="item"></span>
        </div>
        <div class="text">正在加载中哦</div>
      </div>
      <div class="btns">
        <div class="btn" @click="openLh">
          <img src="@/assets/zs_imgs/image-icon.png" alt="" />
        </div>
        <div class="btn" @click="openLive2d">
          <img src="@/assets/zs_imgs/view-icon.png" alt="" />
        </div>
      </div>
    </div>
    <!-- 显示立绘 -->
    <el-dialog
      title=""
      fullscreen
      append-to-body
      custom-class="lh-dialog"
      :visible.sync="lhVisible"
      :after-close="closeLh"
    >
      <div class="lh-container">
        <img :src="dataSource.lh.value" alt="" />
      </div>
    </el-dialog>

    <!-- 显示live2d -->
    <el-dialog
      title=""
      fullscreen
      append-to-body
      custom-class="live2d-dialog"
      :visible.sync="live2dVisible"
      :after-close="closeLive2d"
    >
      <div class="live2d-container" id="__dialog_spine_player_container__" @click="executeAnimation(2)"></div>
    </el-dialog>

    <!-- live2d引导提示 -->
    <div class="guide-box" ref="guide" v-if="!hasViewLive2dGuide">
      <canvas ref="guideCanvas"></canvas>
      <div class="guide-content" ref="guideContent">
        <img class="click-icon" src="@/assets/zs_imgs/click-handler-icon.png" alt="" />
        <img class="line-icon" src="@/assets/zs_imgs/line-to-icon.png" alt="" />
        <div class="dot"></div>
        <div class="tips">点击服装，满满互动！</div>
        <div class="btn" @click="onViewGuide">立即体验</div>
      </div>
    </div>
  </div>
</template>

<script>
import { loadScript, loadCSS } from "@/plugins/util";
export default {
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      lhVisible: false,
      live2dVisible: false,

      isEmpty: false,
      hasViewLive2dGuide: false,
      mainLive2d: {
        container: "__spine_player_container__",
        loading: false,
        spinePlayer: null
      },
      viewLive2d: {
        container: "__dialog_spine_player_container__",
        loading: false,
        spinePlayer: null
      }
    };
  },
  watch: {
    dataSource: {
      handler(newValue, oldValue) {
        this.$nextTick(() => {
          // 初始化
          this.init();
        });
      }
      // deep: true
    }
  },
  mounted() {
    loadCSS(`${process.env.VUE_APP_CDN_BASE}dist/static/spine-player-4.1.54.css?t=10001`);
    loadScript(`${process.env.VUE_APP_CDN_BASE}dist/static/spine-player-4.1.54.js?t=10001`).then(() => {
      // 初始化
      this.init();
    });
  },
  methods: {
    init() {
      this.initSpine(this.mainLive2d);

      // 互动引导
      this.hasViewLive2dGuide = localStorage.getItem("hasViewLive2dGuide");
      if (!this.hasViewLive2dGuide) {
        window.scrollTo(0, 220);
        this.$nextTick(() => {
          document.body.style.overflow = "hidden";
          this.coverGuide(this.$refs.guide, this.$refs.container);
        });
      }
    },
    initSpine(live2d, isView) {
      live2d.loading = true;
      const container = document.getElementById(live2d.container);
      const data = this.dataSource.source.value;

      if (typeof data === "object") {
        if (!data.json) {
          live2d.loading = false;
          return;
        }
        this.isEmpty = false;

        // 先获取到spine可执行的动画
        fetch(data.json)
          .then(response => response.json())
          .then(json => {
            const animations = Object.keys(json.animations);
            container.innerHTML = null;
            // 初始化
            // eslint-disable-next-line
            new window.spine_4_1_54.SpinePlayer(container, {
              // Relative URLs
              jsonUrl: this.foramtUrl(data.json),
              atlasUrl: this.foramtUrl(data.atlas),
              animations: animations,
              showLoading: false,
              showControls: false,
              alpha: true,
              backgroundColor: "#00000000",
              viewport: isView
                ? null
                : {
                    x: -500,
                    y: -500,
                    width: 1000,
                    height: 1000,
                    padLeft: "5%",
                    padRight: "5%",
                    padTop: "50%",
                    padBottom: "50%"
                  },
              success: function(player) {
                live2d.loading = false;
                live2d.spinePlayer = Object.seal(player);
              }
            });
          })
          .catch(() => {
            this.isEmpty = true;
          });
      } else if (data) {
        live2d.loading = false;
        this.isEmpty = false;
        container.innerHTML = `<img class="lh-img" src="${data}" alt="" />`;
      } else {
        live2d.loading = false;
        this.isEmpty = true;
      }
    },
    executeAnimation(type) {
      if (type === 1) {
        const { spinePlayer } = this.mainLive2d;
        this.changeAnimation(spinePlayer);
      } else if (type === 2) {
        const { spinePlayer } = this.viewLive2d;
        this.changeAnimation(spinePlayer);
      }
    },
    changeAnimation(spinePlayer) {
      if (spinePlayer) {
        const animations = spinePlayer.animationState.data.skeletonData.animations;
        // 获取到motion动画
        const motionAnimation = animations.find(item => {
          return item.name === "motion";
        });
        spinePlayer.setAnimation("motion", false);
        setTimeout(() => {
          spinePlayer.setAnimation("idle", true);
        }, motionAnimation.duration * 1000);
      }
    },
    foramtUrl(url) {
      if (url.startsWith("//")) {
        return `${location.protocol}${url}`;
      } else {
        return url;
      }
    },
    openLh() {
      console.log(1);
      this.lhVisible = true;
    },
    closeLh() {
      this.lhVisible = false;
    },
    openLive2d() {
      this.live2dVisible = true;
      this.$nextTick(() => {
        this.initSpine(this.viewLive2d, true);
      });
    },
    closeLive2d() {
      this.live2dVisible = false;
    },
    coverGuide(cover, target) {
      // const body = document.body;
      const doc = document.documentElement;

      function clearRoundRect(context, x, y, width, height, radius) {
        context.save();
        context.beginPath();
        context.roundRect(x, y, width, height, radius);
        context.clip();
        context.clearRect(x, y, width, height);
        context.restore();
      }

      function clearArc(context, x, y, radius) {
        context.save();
        context.beginPath();
        context.arc(x, y, radius, 0, 2 * Math.PI, false);
        context.clip();
        context.clearRect(x - radius - 1, y - radius - 1, radius * 2 + 2, radius * 2 + 2);
        context.restore();
      }
      if (cover && target) {
        // target size(width/height)
        const targetWidth = target.clientWidth;
        const targetHeight = target.clientHeight;

        // page size
        const pageWidth = doc.clientWidth;
        const pageHeight = doc.clientHeight;

        // offset of target
        const offsetTop = target.getBoundingClientRect().top;
        const offsetLeft = target.getBoundingClientRect().left;

        // set size and border-width
        cover.style.width = pageWidth + "px";
        cover.style.height = pageHeight + "px";

        // 设置content位置
        const contentBox = this.$refs.guideContent;
        contentBox.style.top = offsetTop + "px";
        contentBox.style.left = offsetLeft + "px";
        contentBox.style.width = targetWidth + "px";
        contentBox.style.height = targetHeight + "px";

        const canvas = this.$refs.guideCanvas;
        const ctx = canvas.getContext("2d");
        canvas.width = pageWidth;
        canvas.height = pageHeight;
        // ctx.clearRect(0, 0, pageWidth, pageHeight);
        ctx.fillStyle = "rgba(0,0,0,0.75)";
        ctx.fillRect(0, 0, pageWidth, pageHeight);
        // 镂空区域
        clearRoundRect(ctx, offsetLeft, offsetTop, targetWidth, targetHeight, 24);
        ctx.beginPath();
        // 方型镂空区域增加背景
        ctx.fillStyle = "rgba(0,0,0,0.2)";
        ctx.roundRect(offsetLeft, offsetTop, targetWidth, targetHeight, 24);
        ctx.fill();
        ctx.closePath();
        // 镂空区域增加中心圆形镂空
        clearArc(ctx, offsetLeft + targetWidth / 2, offsetTop + targetHeight / 2 - 46, 53);

        // resize
        if (!cover.isResizeBind) {
          window.addEventListener("resize", () => {
            this.coverGuide(cover, target);
          });
          cover.isResizeBind = true;
        }
      }
    },
    onViewGuide() {
      document.body.style.overflow = null;
      this.hasViewLive2dGuide = true;
      localStorage.setItem("hasViewLive2dGuide", true);
    }
  }
};
</script>

<style lang="less" scoped>
.empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  font-size: 12px;
  color: #e4e4e4;
  line-height: 14px;
  margin-top: -100px;
  img {
    width: 190px;
    height: 163px;
    margin-bottom: 7px;
  }
}
.loading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-weight: 400;
  font-size: 12px;
  color: #e4e4e4;
  line-height: 14px;
  .loader {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-bottom: 20px;
    .item {
      display: inline-block;
      position: relative;
      box-sizing: border-box;
      width: 12px;
      height: 12px;
      border-radius: 100%;
      background: #4f6cc2;
      animation: ball-beat 0.7s -0.15s infinite linear;
      &:nth-child(2n-1) {
        animation-delay: -0.5s;
      }
    }

    @keyframes ball-beat {
      50% {
        opacity: 0.2;
        transform: scale(0.75);
      }

      100% {
        opacity: 1;
        transform: scale(1);
      }
    }
  }
}

.live2d {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 638px;
  .container {
    position: relative;
    width: 100%;
    height: 100%;
  }
  /deep/ #__spine_player_container__ {
    position: absolute;
    top: 0;
    left: 0;
    width: 1000px;
    height: 1000px;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translate(calc(-50% + 210px), -104px);
    img {
      max-width: 380px;
      max-height: 792px;
    }
  }

  .bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 638px;
    background: url("~@/assets/zs_imgs/live2d-box-bg.png");
    background-size: 100% 100%;
  }
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1000;
    width: 100%;
    height: 100%;
    background: #ffffff00;
    color: #ffffff00;
    display: flex;
    align-items: center;
    justify-content: center;
    .btns {
      position: absolute;
      right: 0;
      top: 21px;
      width: 68px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      gap: 14px;
    }
    .btn {
      display: inline-block;
      width: 27px;
      height: 27px;
      background: rgba(0, 0, 0, 0.2);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      img {
        width: 18px;
        height: 18px;
      }
    }
  }
}

/deep/ .lh-dialog {
  background-color: rgba(0, 0, 0, 0.77);
  .el-dialog__header {
    position: relative;
    padding: 0;
    margin: 0 auto;
    width: 1000px;
    .el-dialog__headerbtn {
      z-index: 1;
      width: 37px;
      height: 37px;
      background: rgba(255, 255, 255, 0.4);
      border-radius: 50%;
    }
    .el-icon-close {
      color: #fff;
    }
  }
  .el-dialog__body {
    padding: 0;
  }
  .lh-container {
    width: 100%;
    height: 100vh;
    overflow-y: hidden;
    text-align: center;
    img {
      height: 100%;
    }
  }
}

/deep/ .live2d-dialog {
  background-color: rgba(0, 0, 0, 0.9);
  .el-dialog__header {
    position: relative;
    padding: 0;
    margin: 0 auto;
    width: 1000px;
    .el-dialog__headerbtn {
      z-index: 1;
      width: 37px;
      height: 37px;
      background: rgba(255, 255, 255, 0.4);
      border-radius: 50%;
    }
    .el-icon-close {
      color: #fff;
    }
  }
  .el-dialog__body {
    padding: 0;
  }
  .live2d-container {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow-y: hidden;
    text-align: center;
  }
}

.guide-box {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  width: 100vw;
  height: 100vh;
  canvas {
    width: 100%;
    height: 100%;
  }
  .guide-content {
    position: absolute;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-top: 320px;

    .click-icon {
      width: 55px;
      height: 70px;
      margin-bottom: 25px;
    }
    .line-icon {
      width: 3px;
      height: 181px;
      margin-bottom: 11px;
    }
    .dot {
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #757474;
      border-radius: 50%;
      margin-bottom: 16px;
      &::after {
        content: "";
        display: block;
        width: 8px;
        height: 8px;
        background: #fff;
        border-radius: 50%;
      }
    }
    .tips {
      font-weight: bold;
      font-size: 22px;
      color: #ffffff;
      line-height: 23px;
      margin-bottom: 29px;
    }

    .btn {
      width: 134px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(123, 213, 255, 0.5);
      border-radius: 20px;
      font-weight: 400;
      font-size: 16px;
      color: #82fff8;
      cursor: pointer;
    }
  }
}
</style>
